// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"vendors-_yarn_berry_cache_dompurify-npm-2_5_8-e124d1b8e9-10c0_zip_node_modules_dompurify_dist-349605":"6199440d90818fab9d3a","vendors-_yarn_berry_cache_canvg-npm-3_0_11-0944b07da2-10c0_zip_node_modules_canvg_lib_index_es_js":"b8bf48a7ae4692b6190c"}[chunkId] + ".js";
};